import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'list',
    component: () => import('../views/classification/index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login.vue')
  },

  {
    path: '/questions',
    name: 'questions',
    component: () => import('../views/classification/questions.vue')
  },
  {
    path: '/pattern',
    name: 'pattern',
    component: () => import('../views/classification/pattern.vue')
  },
  {
    path: '/fraction',
    name: 'fraction',
    component: () => import('../views/classification/fraction.vue')
  },
  {
    path: '/record',
    name: 'record',
    component: () => import('../views/classification/record.vue')
  }
];

const router = new VueRouter({
  routes
});

export default router;
